<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="缺陷类型" prop="defType">
              <a-radio-group
                @change="defTypeChange"
                button-style="solid"
                v-if="!model.id"
                v-model:value="model.defType"
              >
                <a-radio-button value="1">设备类</a-radio-button>
                <a-radio-button value="2">非设备类</a-radio-button>
              </a-radio-group>
              <div v-else>{{model.defType==2?'非设备类':'设备类'}}</div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <fieldset v-if="model.defType == '1'">
          <legend>&nbsp;缺陷设备&nbsp;</legend>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备名称" prop="devId">
                <j-tree-select-device
                  :disabled="Object.prototype.hasOwnProperty.call(model, 'id')"
                  @change="devIdChange"
                  placeholder="请选择设备"
                  v-model="model.devId"
                ></j-tree-select-device>
              </a-form-model-item>

              <a-input placeholder="请输入设备名称" v-model="model.devName" v-show="false"></a-input>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备类型">
                <a-input disabled v-model="model.devClassCode_dictText" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </fieldset>
        <fieldset>
          <legend>&nbsp;缺陷描述&nbsp;</legend>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="缺陷标准" prop="defStandardId">
                <j-select-def-standard
                  :defType="model.defType"
                  :devClassCode="model.devClassCode"
                  :multiple="false"
                  @change="defStandardChange"
                  placeholder="请选择缺陷标准"
                  v-model="model.defStandardId"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="缺陷等级" prop="defLevel">
                <a-radio-group :disabled="defLevelDisabled" button-style="solid" v-model:value="model.defLevel">
                  <a-radio-button value="1">一般</a-radio-button>
                  <a-radio-button value="2">严重</a-radio-button>
                  <a-radio-button value="3">危急</a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <!--  <a-col :span="12">
                            <a-form-model-item label="缺陷标准名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="defStandardName">
                                <a-input v-model="model.defStandardName" placeholder="请输入缺陷标准名称"></a-input>
                            </a-form-model-item>
            </a-col>-->
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
                :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
                label="缺陷内容"
                prop="defContent"
              >
                <a-textarea allow-clear placeholder="请输入缺陷内容" v-model="model.defContent"></a-textarea>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
                :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
                label="缺陷图片"
                prop="defPicture"
              >
                <a-upload
                  :action="minioUploadAction"
                  :before-upload="beforeUpload"
                  :file-list="model.defPicture"
                  :headers="tokenHeader"
                  @change="handleChange"
                  @preview="handlePreview"
                  accept="image/*"
                  listType="picture-card"
                >
                  <div v-if="model.defPicture.length < 4">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传缺陷图片</div>
                  </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                  <img :src="previewImage" alt="example" style="width: 100%" />
                </a-modal>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
                :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
                label="缺陷视频"
                prop="defVideo"
              >
                <a-upload
                  :action="minioUploadAction"
                  :before-upload="beforeUpload1"
                  :file-list="model.defVideo"
                  :headers="tokenHeader"
                  @change="handleChange1"
                  @preview="videoPreview"
                  accept="video/*"
                  listType="picture-card"
                >
                  <div v-if="model.defVideo.length < 4">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传缺陷视频</div>
                  </div>
                </a-upload>
                <a-modal :footer="null" :visible="videoPreviewVisible" @cancel="handleCancel1">
                  <video controls="controls" height="100%" id="video" width="100%">您的浏览器不支持播放该视频！</video>
                </a-modal>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="缺陷发现人" prop="defInventor">
                <j-dict-select-tag
                  :dictCode="`sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get('TENANT_ID')}' order by realname`"
                  pageSize="100"
                  placeholder="请选择缺陷发现人"
                  type="list"
                  v-model="model.defInventor"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="缺陷处理人" prop="defHandle">
                <j-dict-select-tag
                  :dictCode="`sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get('TENANT_ID')}' order by realname`"
                  pageSize="100"
                  placeholder="请选择缺陷处理人"
                  type="list"
                  v-model="model.defHandle"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话" prop="defTelephone">
                <a-input placeholder="请输入联系电话" v-model="model.defTelephone"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="缺陷发现时间" prop="defFindTime">
                <j-date
                  :showTime="true"
                  dateFormat="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择缺陷发现时间"
                  v-model="model.defFindTime"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </fieldset>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import moment from 'moment'
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import { getUserList } from '@/api/api'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: 'DefRegisterForm',
    mixins: [JeecgListMixin],
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
    },
    data () {
      return {
        disableMixinCreated: true,
        model: {
          defType: '1',
          devId: '',
          devName: '',
          devClassCode: '',
          devClassCode_dictText: '',
          defStandardId: '',
          defContent: '',
          defFindTime: moment(new Date(), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'), //默认值
          defPicture: [],
          defVideo: [],
          defInventor: '',
          defHandle: '',
          defStandardName: '',
          defLevel: '1',
          defTelephone: '',
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          defType: [
            { required: true, message: '请选择缺陷类型!' },
          ],
          devId: [
            { required: true, message: '请输入设备名称!' },
          ],
          devClassCode: [
            { required: true, message: '请选择设备类型!' },
          ],
          defLevel: [
            { required: true, message: '请选择缺陷等级!' },
          ],
          defContent: [
            { required: true, message: '请输入缺陷内容!' },
          ],
          defInventor: [
            { required: true, message: '请选择缺陷发现人!' },
          ],
          /* defHandle: [
            { required: true, message: '请选择缺陷处理人!' },
          ], */
          defTelephone: [
            { required: true, message: '请输入联系电话!' },
          ],
          defFindTime: [
            { required: true, message: '请选择缺陷发现时间!' },
          ],
        },
        url: {
          add: "/device/defRegister/add",
          edit: "/device/defRegister/edit",
          queryById: "/device/defRegister/queryById",
          selectDev: "/device/devList/list",
          selectClass: '/device/devClass/selectDropList',
          selectStandardById: "/device/defStandard/queryById?id=",
          minioUpload: "/sys/upload/uploadMinio",
          register: "/device/defRegister/register",
        },
        devList: [],
        standardList: [],
        UserOptions1: [],
        UserOptions2: [],
        previewVisible: false,
        previewImage: '',
        videoPreviewVisible: false,
        previewVideo: '',
        defLevelDisabled: false,
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
      minioUploadAction () {
        return window._CONFIG['domianURL'] + this.url.minioUpload;
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    watch: {
      //预览并播放视频时,如果关闭了弹框,电脑还有视频的声音,监听视频预览的弹框的打开/关闭,如果关闭了弹框就让video不要播放了
      videoPreviewVisible: function (val) {
        if (val === false) {
          const video = document.getElementById('video')
          video.pause()
        }
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      //初始化设备
      this.getDevList()
      this.remoteUserList1()
      this.remoteUserList2()
    },
    methods: {
      add (devId) {
        if (devId) {
          this.modelDefault.devId = devId
        }
        this.modelDefault.defInventor = this.$ls.get('Login_UserId')
        this.modelDefault.defHandle = this.$ls.get('Login_UserId')
        this.modelDefault.defTelephone = validatenull(this.userInfo.phone) ? this.userInfo.telephone : this.userInfo.phone
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        if (validatenull(this.model.defPicture)) {
          this.model.defPicture = []
        }
        if (validatenull(this.model.defVideo)) {
          this.model.defVideo = []
        }

        if (validatenotnull(this.model.devId)) {
          this.devIdChange2(this.model.devId)
        }
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok', res.result.id);
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      registerForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            httpAction(this.url.register, this.model, 'post').then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok', res.result.id);
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      getDevList () {
        getAction(this.url.selectDev, { pageSize: 999999 }).then(res => {
          this.devList = res.result.records
        })
      },
      devIdChange (e) {
        var hh = this.devList.filter((c) => {
          if (c.id == e) {
            this.model.devName = c.devName
            this.model.devClassCode = c.devClassCode;
            this.model.devClassCode_dictText = c.devClassCode_dictText;
          }
        })
      },
      devIdChange2 (e) {
        getAction(this.url.selectDev, { pageSize: 999999 }).then(res => {
          this.devList = res.result.records
          var hh = this.devList.filter((c) => {
            if (c.id == e) {
              this.model.devName = c.devName;
              this.model.devClassCode = c.devClassCode;
              this.model.devClassCode_dictText = c.devClassCode_dictText;
            }
          })
        })
      },
      defTypeChange (v) {
        this.model.devId = ''
        this.model.devName = ''
        this.model.devClassCode = ''
        this.model.devClassCode_dictText = ''
        this.model.defStandardId = ''
        this.standardList = []
        this.model.defStandardName = ''
        this.model.defLevel = '1'
        this.model.defContent = ''
        this.defStandardChange()
      },
      defStandardChange (e) {
        if (validatenull(e)) {
          this.model.defStandardName = ''
          this.model.defLevel = '1'
          this.model.defContent = ''
          this.defLevelDisabled = false
          return
        }
        getAction(this.url.selectStandardById + e).then(res => {
          if (res.success) {
            let result = res.result
            this.model.defStandardName = result.defPart + ':' + result.defCategory
            this.model.defLevel = result.defLevel
            this.model.defContent = result.remarks
            this.defLevelDisabled = true
          } else {
            this.$message.warning('缺陷标准库查询失败.' + res.message);
          }

        })
      },
      defInventorChange (e) {
        var hh = this.UserOptions1.filter((c) => {
          if (c.id == e) {
            this.model.defTelephone = validatenull(c.phone) ? c.telephone : c.phone
          }
        })
      },
      remoteUserList1 (query) {
        let params = {
          username: query,
          // realname: query,
          // phone: query,
          // workNo: query
        }
        let sqp = {}
        // sqp['superQueryParams'] = encodeURI(params)
        // sqp['superQueryMatchType'] = 'or'
        getUserList(Object.assign(sqp, { pageSize: 999999 })).then(res => {
          this.UserOptions1 = res.result.records;
        })
      },
      remoteUserList2 (query) {
        let params = {
          username: query,
          // realname: query,
          // phone: query,
          // workNo: query
        }
        let sqp = {}
        // sqp['superQueryParams'] = encodeURI(params)
        // sqp['superQueryMatchType'] = 'or'
        getUserList(Object.assign(sqp, { pageSize: 999999 })).then(res => {
          this.UserOptions2 = res.result.records;
        })
      },
      filterOption (input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      handleCancel () {
        this.previewVisible = false
      },
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
      },
      handleChange (info) {
        if (info.file.status === 'done') {
          if (info.file.response.success) {
            this.$message.success(`${info.file.name} 上传成功!`);
          } else {
            this.$message.error(`${info.file.response.message}`);
          }
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.response.message}`);
        }
        if (validatenotnull(info.fileList)) {
          this.model.defPicture = info.fileList.map(item => {
            let url = (validatenotnull(item.url)) ? item.url : ((validatenotnull(item.response) && validatenotnull(item.response.message)) ? item.response.message : '')
            return {
              uid: item.uid,
              name: item.name,
              status: item.status,
              url: url
            }
          })
          // console.error(this.model.defPicture)
          // console.error(info.fileList)
        }
      },
      beforeUpload (file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          this.$message.error('You can only upload JPG/PNG file!');
        }
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          this.$message.error('Image must smaller than 10MB!');
        }
        return isJpgOrPng && isLt10M;
      },
      handleCancel1 () {
        this.videoPreviewVisible = false
      },
      handleChange1 (info) {
        if (info.file.status === 'done') {
          if (info.file.response.success) {
            this.$message.success(`${info.file.name} 上传成功!`);
          } else {
            this.$message.error(`${info.file.response.message}`);
          }
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.response.message}`);
        }
        if (validatenotnull(info.fileList)) {
          this.model.defVideo = info.fileList.map(item => {
            let url = (validatenotnull(item.url)) ? item.url : ((validatenotnull(item.response) && validatenotnull(item.response.message)) ? item.response.message : '')
            return {
              uid: item.uid,
              name: item.name,
              status: item.status,
              url: url
            }
          })
          // console.error(this.model.defVideo)
          // console.error(info.fileList)
        }
      },
      beforeUpload1 (file) {
        const isVideo = file.type === 'video/mp4' || file.type === 'video/ogg' || file.type === 'video/webm';
        if (!isVideo) {
          this.$message.error('You can only upload video file!');
        }
        const isLt50M = file.size / 1024 / 1024 < 50;
        if (!isLt50M) {
          this.$message.error('Image must smaller than 50MB!');
        }
        return isVideo && isLt50M;
      },
      videoPreview (file) {
        //预览视频的方法
        this.videoPreviewVisible = true;
        this.$nextTick(() => {	//这里一定要使用nextTick,否则document将找不到id为video的节点,因为modal框初始为隐藏状态,<video id='video'>标签初始在dom树中并不存在
          const video = document.getElementById('video')
          video.src = file.url
        })
      },
    }
  }
</script>